module.exports = __webpack_public_path__ + "img/img1.9b07ee81.png";